import Config from '../../config';

export const isTrialLicense = (license) => license && license.licenseType === 'TRIAL';

export const isActiveLicense = (license) => license && !license.expired;

const isMatManLicense = (license) =>
  license && license.product.family.code === Config.productFamilyCode;

export const findPriorityLicense = (licenses) => {
  const productLicenses = licenses.filter(isMatManLicense);
  if (!productLicenses.length) return null; // CSC - no license???

  const license = productLicenses.find((l) => !isTrialLicense(l) && isActiveLicense(l));
  if (license) return license;

  const trialLicense = productLicenses.find((l) => isTrialLicense(l) && isActiveLicense(l));
  if (trialLicense) return trialLicense;

  // most recently expired purchased license, or most recent expired trial license
  return productLicenses.find((l) => !isTrialLicense(l)) || productLicenses[0];
};
